import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  listContainer: {
    maxWidth: 700,
    display: "flex",
    flexDirection: "column",
    padding: theme.spacing(6, 0),
  },
  commentContainer: {
    padding: theme.spacing(4, 0),
  },
  commentBox: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-end",
  },
  textArea: {
    height: "auto!important",
  },
  commentButton: {
    alignSelf: "flex-end",
  },
  loader: {
    width: "100%",
    height: 100,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
}));

export default useStyles;
